import { tMessageErrorType } from '../../providers/SocketsProvider/Sockets.types.ts';
import { tChatEventError } from './Chat.types.ts';

/**
 * INT-1500 U3 / contract C3: a socket event's error rows as the chat keeps
 * them. The whole `error` object is kept, so Meta's `metaCode` and `details`
 * reach the Meta error notice without a reload.
 *
 * Its own module, not Chat.utils: several suites mock Chat.utils wholesale,
 * and both socket paths (insert and update) need this.
 */
export function toChatEventErrors(
  errors: tMessageErrorType[] | undefined,
): tChatEventError[] | undefined {
  return errors?.map(({ code, error }) => ({ code, error: error ?? null }));
}
